import React from 'react'
import { FileText, RotateCcw, Mail, AlertCircle } from 'lucide-react'

import { C } from './theme'

const wrap = {
  maxWidth: '800px', margin: '0 auto', padding: '24px 28px',
  fontSize: '14px', lineHeight: '1.6', color: C.text,
}
const h1 = { fontSize: '24px', fontWeight: '700', color: C.text, margin: '0 0 6px', display: 'flex', alignItems: 'center', gap: '10px' }
const h2 = { fontSize: '17px', fontWeight: '700', color: C.text, margin: '24px 0 10px', paddingBottom: '6px', borderBottom: `1px solid ${C.border}` }
const sub = { fontSize: '13px', color: C.textMuted, margin: '0 0 24px' }
const aviso = { padding: '12px 14px', background: '#eff6fc', border: `1px solid #c7e0f4`, borderRadius: '4px', margin: '12px 0', display: 'flex', gap: '8px', alignItems: 'flex-start' }

export function TermosUtilizacao() {
  return (
    <div style={wrap}>
      <h1 style={h1}><FileText size={24} color={C.primary} /> Termos e Condições</h1>
      <p style={sub}>LogiStock Pro · última actualização: 14/05/2026</p>

      <h2 style={h2}>1. Identificação do Vendedor</h2>
      <p><strong>Catia Andreia da Silva</strong> (Empresário em Nome Individual)<br/>
      NIF: 241288398<br/>
      Morada: Avenida da Ponte, n.º 75, 4795-550 Negrelos<br/>
      Email: <a href="mailto:comercial@lognow.pt" style={{ color: C.primary }}>comercial@lognow.pt</a><br/>
      Tel: +351 963 980 628</p>

      <h2 style={h2}>2. Objecto</h2>
      <p>Estas condições regulam a compra de produtos de cosmética e perfumaria através da plataforma <strong>LogiStock Pro</strong>. Ao concluir uma encomenda, o cliente declara aceitar integralmente estes termos.</p>

      <h2 style={h2}>3. Tipo de Cliente</h2>
      <p>A plataforma destina-se a <strong>clientes empresariais (B2B)</strong> — Empresas e ENIs previamente aprovados, com apresentação fiscal completa. As condições de pagamento dependem do prazo de entrega do artigo: <strong>100% à compra</strong> nos artigos de entrega rápida, ou <strong>duas prestações</strong> (50% à compra + 50% antes do envio) nos de prazo mais longo.</p>

      <h2 style={h2}>4. Encomendas e Preços</h2>
      <ul>
        <li>A plataforma reserva-se o direito de recusar encomendas em caso de erro manifesto de preço, indisponibilidade de stock ou suspeita de fraude.</li>
        <li>Os portes de envio estão incluídos no preço apresentado (sem custos adicionais para Portugal Continental).</li>
        <li>O prazo de entrega varia com o artigo e está indicado no catálogo, sendo confirmado no carrinho antes de finalizar a encomenda. Conta-se após confirmação do pagamento.</li>
        <li>Podem aplicar-se valores mínimos de encomenda distintos consoante o prazo de entrega do artigo; o valor em vigor é apresentado no carrinho.</li>
      </ul>

      <h2 style={h2}>5. Pagamento</h2>
      <ul>
        <li>O pagamento é efectuado por <strong>transferência bancária</strong> para o IBAN indicado na confirmação da encomenda.</li>
        <li>O cliente deve incluir sempre a <strong>referência da encomenda</strong> na descrição da transferência.</li>
        <li>O comprovativo deve ser anexado na área pessoal do cliente, acelerando a confirmação.</li>
        <li>A encomenda só é processada após confirmação efectiva do pagamento pelo administrador.</li>
      </ul>

      <h2 style={h2}>7. Garantia Legal</h2>
      <p>Os bens vendidos beneficiam da garantia legal de conformidade prevista no <strong>Decreto-Lei n.º 84/2021</strong> (2 anos para bens móveis). Defeitos de fabrico ou desconformidades devem ser comunicados pelo email <a href="mailto:comercial@lognow.pt" style={{ color: C.primary }}>comercial@lognow.pt</a> com fotos e descrição.</p>

      <h2 style={h2}>7. Protecção de Dados (RGPD)</h2>
      <p>Os dados pessoais recolhidos (nome, email, NIF, morada, telefone) são utilizados exclusivamente para:</p>
      <ul>
        <li>Processar encomendas e emitir factura</li>
        <li>Comunicar sobre o estado da encomenda</li>
        <li>Cumprir obrigações fiscais e contabilísticas (arquivo legal de 10 anos)</li>
      </ul>
      <p>Para fins de <strong>segurança e detecção de acessos não autorizados</strong>, recolhemos automaticamente o <strong>endereço IP</strong>, <strong>tipo de dispositivo</strong> e <strong>navegador</strong> em cada visita à plataforma. Estes dados são <strong>eliminados automaticamente ao fim de 90 dias</strong> e só são acedidos pelo administrador para auditoria.</p>
      <p>Os dados <strong>não são partilhados com terceiros</strong> excepto para entidades obrigatórias (Autoridade Tributária, transportadora). O cliente pode pedir acesso, rectificação ou eliminação dos seus dados pelo email indicado.</p>

      <h2 style={h2}>8. Reclamações</h2>
      <p>Reclamações devem ser apresentadas por email <a href="mailto:comercial@lognow.pt" style={{ color: C.primary }}>comercial@lognow.pt</a> ou através do <strong>Livro de Reclamações Electrónico</strong> em <a href="https://www.livroreclamacoes.pt" target="_blank" rel="noopener noreferrer" style={{ color: C.primary }}>livroreclamacoes.pt</a>.</p>

      <h2 style={h2}>9. Resolução de Litígios</h2>
      <p>Em caso de litígio, o cliente pode recorrer ao <strong>Centro de Arbitragem de Conflitos de Consumo</strong> da sua área de residência. Foro competente: Tribunal Judicial de Penafiel.</p>

      <h2 style={h2}>10. Alterações</h2>
      <p>Estes termos podem ser actualizados. A versão em vigor é sempre a publicada nesta página. Encomendas anteriores regem-se pela versão à data da compra.</p>

      <div style={aviso}>
        <AlertCircle size={16} color={C.primary} style={{ flexShrink: 0, marginTop: '2px' }} />
        <div style={{ fontSize: '12px', color: C.text }}>
          <strong>Programa Beta:</strong> Esta plataforma encontra-se em fase de testes com um grupo restrito de clientes. Sugestões e feedback são muito bem-vindos.
        </div>
      </div>
    </div>
  )
}

export function PoliticaDevolucao() {
  return (
    <div style={wrap}>
      <h1 style={h1}><RotateCcw size={24} color={C.primary} /> Política de Devolução</h1>
      <p style={sub}>Direito de retractação · Decreto-Lei n.º 24/2014</p>

      <div style={aviso}>
        <AlertCircle size={16} color={C.primary} style={{ flexShrink: 0, marginTop: '2px' }} />
        <div style={{ fontSize: '13px', color: C.text }}>
          <strong>Esta política aplica-se aos consumidores enquadrados no DL 24/2014.</strong> Clientes empresariais regem-se pelas condições comerciais específicas.
        </div>
      </div>

      <h2 style={h2}>1. Prazo</h2>
      <p>Tem <strong>14 dias corridos</strong> para devolver os produtos, contados a partir do dia em que recebe a encomenda. Não necessita de indicar motivo.</p>

      <h2 style={h2}>2. Condições</h2>
      <p>Para que a devolução seja aceite:</p>
      <ul>
        <li>O produto deve estar <strong>fechado, na embalagem original e selada</strong> (selo de fábrica intacto).</li>
        <li>Não podem ter sido removidas etiquetas, plásticos protectores ou selos de segurança.</li>
        <li>O cliente é responsável por garantir que o produto chega em condições adequadas.</li>
      </ul>

      <div style={{ ...aviso, background: '#fff4ce', borderColor: '#f0d070' }}>
        <AlertCircle size={16} color={C.warning} style={{ flexShrink: 0, marginTop: '2px' }} />
        <div style={{ fontSize: '12px', color: C.text }}>
          <strong>Exclusão legal:</strong> Os perfumes e cosméticos selados <strong>perdem o direito de retractação se forem desselados após a entrega</strong>, por razões de higiene e protecção da saúde (DL 24/2014, art. 17.º n.º 1 alínea e)). Verifique sempre o produto antes de abrir.
        </div>
      </div>

      <h2 style={h2}>3. Como Devolver</h2>
      <ol>
        <li>Envie um email para <a href="mailto:comercial@lognow.pt" style={{ color: C.primary, fontWeight: '600' }}>comercial@lognow.pt</a> com o assunto "Devolução [Nº Encomenda]".</li>
        <li>Indique no email: número da encomenda, produto(s) a devolver, motivo (opcional) e dados para reembolso (IBAN).</li>
        <li>Receberá instruções de envio nas 48 horas seguintes.</li>
        <li>Embale o produto cuidadosamente na embalagem original.</li>
        <li>Envie por correio registado ou transportadora à sua escolha.</li>
      </ol>

      <h2 style={h2}>4. Custos de Devolução</h2>
      <p>Os <strong>custos de envio para devolução são por conta do cliente</strong>, conforme o art. 13.º n.º 2 do DL 24/2014. Excepção: se o produto chegou defeituoso, danificado ou diferente do encomendado — nesse caso suportamos integralmente os custos.</p>

      <h2 style={h2}>5. Reembolso</h2>
      <ul>
        <li>O reembolso é efectuado no prazo de <strong>14 dias</strong> a partir da recepção do produto devolvido em condições aceitáveis.</li>
        <li>O reembolso é feito por <strong>transferência bancária</strong> para o IBAN indicado pelo cliente.</li>
        <li>Reembolso integral do preço pago pelo produto (não inclui custos de envio originais se já tivessem sido facturados separadamente — não é o caso, portes estão incluídos).</li>
      </ul>

      <h2 style={h2}>6. Produtos Defeituosos ou Errados</h2>
      <p>Se receber um produto:</p>
      <ul>
        <li><strong>Defeituoso</strong> (não funciona, embalagem partida na chegada, conteúdo deteriorado)</li>
        <li><strong>Diferente do encomendado</strong> (referência errada, quantidade incorrecta)</li>
        <li><strong>Em condições inaceitáveis</strong></li>
      </ul>
      <p>Contacte-nos no prazo de <strong>48 horas após a recepção</strong>, com fotos e descrição. Será efectuada substituição ou reembolso integral, com custos de envio totalmente suportados pelo vendedor.</p>

      <h2 style={h2}>7. Contacto</h2>
      <p>Para qualquer dúvida sobre devoluções:<br/>
      Email: <a href="mailto:comercial@lognow.pt" style={{ color: C.primary, fontWeight: '600' }}>comercial@lognow.pt</a><br/>
      Tel: +351 963 980 628</p>

      <h2 style={h2}>8. Formulário Modelo de Retractação</h2>
      <p>Pode usar o seguinte modelo (não obrigatório):</p>
      <div style={{ padding: '14px 16px', background: '#fafafa', border: `1px solid ${C.border}`, borderRadius: '4px', fontFamily: 'monospace', fontSize: '12px', whiteSpace: 'pre-wrap', color: C.text }}>
{`Para: Catia Andreia da Silva
Email: comercial@lognow.pt

Pelo presente, comunico que pretendo resolver o meu contrato de
compra e venda dos seguintes produtos:

  - [Indicar produto(s) e quantidade]

Encomenda Nº: [.........]
Data da encomenda: [.........]
Data de recepção: [.........]
Nome: [.........]
Morada: [.........]
NIF: [.........]
IBAN para reembolso: [.........]

Data: ............
Assinatura: ............`}
      </div>
    </div>
  )
}
